import { TravelExpenseAuditNotesDTO, TravelExpenseAuditNotesSTO } from "../../models/travel-expense-audit-notes";
import { BaseApiService } from "../base";

export class TravelExpenseAuditNotesApiService extends BaseApiService<
  TravelExpenseAuditNotesDTO,
  TravelExpenseAuditNotesSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeExpenseReports",
      loadItemsPath: "/GetTravelExpenseAuditNotes",
      saveItemsPath: "/SaveTravelExpenseAuditNotes",
    });
  }
}
